import React from "react";
import {
  IControlLayout,
  IControlProperty,
  ILayoutTemplate,
} from "../../../Context/PDFEditorContext";

type Props = {
  layout: IControlLayout;
};

const StaticLine = ({ layout }: Props) => {
  const attribute = layout.template.attribute as IControlProperty;
  return (
    <div
      style={{
        width: attribute.drawAxit === "horizontal" ? "100%" : "auto",
        height: attribute.drawAxit === "vertical" ? "100%" : "auto",
        // background: attribute && "color" in attribute ? attribute?.color : "",
        borderLeft:
          attribute.drawAxit === "vertical"
            ? `${attribute.fontSize}px ${attribute.lineStyle} ${
                attribute && "color" in attribute ? attribute?.color : ""
              }`
            : "unset",
        borderBottom:
          attribute.drawAxit === "horizontal"
            ? `${attribute.fontSize}px ${attribute.lineStyle} ${
                attribute && "color" in attribute ? attribute?.color : ""
              }`
            : "unset",
      }}
    />
  );
};

export default StaticLine;
